/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerActualConfig } from '../../config/header.config';
export interface IHeaderActualPluginMethods extends IPluginMethodMap {
  getHeaderActualSync(args?: any): any;
}

export class HeaderActualPlugin implements IAgentPlugin {
  readonly methods: IHeaderActualPluginMethods;

  constructor() {
    this.methods = {
      getHeaderActualSync: this.getHeaderActualSync.bind(this),
    };
  }

  getHeaderActualSync(args?: any) {
    return {
      header: headerActualConfig,
    };
  }
}
